class Header {
    constructor() {
        this.body = document.querySelector('body');
        this.navigation = document.querySelector('nav[data-main-nav]');
        this.toggleMenuMobileButton = document.querySelector('button[data-toggle-mobile-menu]');
        this.menuMobile = document.querySelector('[data-mobile-menu]');
        this.toggleMobileSubMenus = document.querySelectorAll('button[data-menu-sub-item]');
        this.closeMobileSubMenus = document.querySelectorAll('button[data-close-sub-menu]');
        this.mobileSubMenuAccordions = document.querySelectorAll('[data-sub-menu-accordion-context]');
        this.toggleDesktopSubMenus = document.querySelectorAll('button[data-header-toggle-menu]');
        this.desktopSubMenus = document.querySelectorAll('[data-header-sub-menu]');
        this.desktopSubMenuOverlays = document.querySelectorAll('[data-sub-menu-overlay]');
        this.announcementBar = document.getElementById('shopify-section-announcement-bar');

        this.predictiveSearch = document.querySelector('predictive-search');
        this.predictiveSearchModal = document.querySelector('modal-dialog[id=PredictiveSearch]');

        this.desktopBreakpoint = 1280;

        this.menuEventListeners();

        this.announcementBarCheck();
    }

    menuEventListeners () {
        this.toggleMenuMobileButton.addEventListener('click', () => {
            this.toggleMobileMenu(this.menuMobile);
            this.toggleMobileBodyOverflow();
            this.animateMobileIcon();
        })

        this.toggleMobileSubMenus.forEach(toggle => {
            toggle.addEventListener('click', (event) => {
                if (window.innerWidth < this.desktopBreakpoint) {
                    const menu = event.target.nextElementSibling;
                    this.toggleMobileMenu(menu);
                }
            })
        })

        this.closeMobileSubMenus.forEach(close => {
            close.addEventListener('click', (event) => {
                const menu = event.target.closest('div[data-sub-menu]');
                this.toggleMobileMenu(menu);
            })
        })

        this.mobileSubMenuAccordions.forEach(mobileSubMenuAccordion => {
            const trigger = mobileSubMenuAccordion.querySelector('[data-sub-menu-accordion-trigger]');

            trigger.addEventListener('click', () => {
                trigger.querySelector('[data-sub-menu-accordion-trigger-icon]').classList.toggle('is-active');
                mobileSubMenuAccordion.querySelector('[data-sub-menu-accordion-content').classList.toggle('is-active');
            });
        })

        this.toggleDesktopSubMenus.forEach(button => {
            button.addEventListener('click', (event) => {
                if (window.innerWidth >= this.desktopBreakpoint) {
                    const menu = event.currentTarget.nextElementSibling;
                    this.toggleDesktopSubMenu(menu, event.currentTarget);
                }
            })
        })

        if (this.desktopSubMenuOverlays && this.desktopSubMenuOverlays.length > 0) {
            this.desktopSubMenuOverlays.forEach(button => {
                button.addEventListener('click', () => {
                    this.closeAllDesktopSubMenus();
                    this.removeInactiveItemsTextColour();
                })
            })
        }

        document.addEventListener("click", (event) => {
            if (!this.navigation.contains(event.target)) {
                this.closeAllDesktopSubMenus();
            }
        })
    }

    toggleMobileMenu (menu) {
        if (this.announcementBar) {
            // Adds offset of announcement bar to mobile menu
            this.menuMobile.style.setProperty('--announcement-bar-offset-mobile', `${Math.max(this.announcementBar.getBoundingClientRect().height - window.scrollY, 0) / 16}rem`);
        }

        if (menu.classList.contains('xLargeMax:translate-x-0')) {
            menu.classList.remove('xLargeMax:translate-x-0');
            menu.classList.add('xLargeMax:-translate-x-full');
            if (menu.hasAttribute('data-sub-menu')) {
                menu.querySelector('[data-close-sub-menu]').setAttribute('aria-expanded', false);
            }
        } else {
            menu.classList.add('xLargeMax:translate-x-0');
            menu.classList.remove('xLargeMax:-translate-x-full');
            if (menu.hasAttribute('data-sub-menu')) {
                menu.querySelector('[data-close-sub-menu]').setAttribute('aria-expanded', true);
            }
        }
    }

    toggleMobileBodyOverflow () {
        if (this.menuMobile.classList.contains('xLargeMax:translate-x-0')) {
            this.body.classList.add('xLargeMax:overflow-hidden');
        } else {
            this.body.classList.remove('xLargeMax:overflow-hidden');
        }
    }

    animateMobileIcon () {
        const top = document.querySelector('.js-mobile-menu-top');
        const mid = document.querySelector('.js-mobile-menu-mid');
        const btm = document.querySelector('.js-mobile-menu-btm');

        if (this.toggleMenuMobileButton.classList.contains('xLargeMax:z-60')) {
            this.toggleMenuMobileButton.classList.remove('xLargeMax:z-60');
            top.classList.remove('xLargeMax:rotate-45');
            top.classList.remove('xLargeMax:top-1/2');
            mid.classList.remove('xLargeMax:opacity-0');
            btm.classList.remove('xLargeMax:-rotate-45');
            btm.classList.remove('xLargeMax:top-1/2');
            btm.classList.remove('xLargeMax:w-full');
        } else {
            this.toggleMenuMobileButton.classList.add('xLargeMax:z-60');
            top.classList.add('xLargeMax:rotate-45');
            top.classList.add('xLargeMax:top-1/2');
            mid.classList.add('xLargeMax:opacity-0');
            btm.classList.add('xLargeMax:-rotate-45');
            btm.classList.add('xLargeMax:top-1/2');
            btm.classList.add('xLargeMax:w-full');
        }
    }

    toggleDesktopSubMenu (menu, button) {
        const svg = button.querySelector('[data-desktop-menu-caret]');
        const isTopLevelLink = button.dataset.headerTopLevel;
        const hoverElement = button.querySelector('[data-menu-sub-menu]');
        if (menu.classList.contains('xLarge:opacity-0')) {
            if (isTopLevelLink) {
                this.closeAllDesktopSubMenus();
            }
            menu.classList.remove('xLarge:opacity-0');
            menu.classList.remove('xLarge:invisible');
            menu.classList.remove('xLarge:h-0');
            svg.classList.add('xLarge:rotate-180');
            menu.closest('[data-sub-menu]').setAttribute('aria-expanded', true);
            if (hoverElement) {
                hoverElement.classList.add('xLarge:opacity-100');
                console.log('contains xLarge:opacity-0 - add xLarge:opacity-100');
            }    
        } else {
            menu.classList.add('xLarge:opacity-0');
            menu.classList.add('xLarge:invisible');
            menu.classList.add('xLarge:h-0');
            svg.classList.remove('xLarge:rotate-180');
            menu.closest('[data-sub-menu]').setAttribute('aria-expanded', false);
            if (hoverElement) {
                hoverElement.classList.remove('xLarge:opacity-100');
                console.log('doesnt contain xLarge:opacity-0 - remove xLarge:opacity-100');
            }
        }
    }

    closeAllDesktopSubMenus () {
        this.desktopSubMenus.forEach(menu => {
            if (!menu.classList.contains('xLarge:opacity-0')) {
                menu.classList.add('xLarge:opacity-0');
                menu.classList.add('xLarge:invisible');
                menu.classList.add('xLarge:h-0');
            }
        })

        this.toggleDesktopSubMenus.forEach(button => {
            const svg = button.querySelector('[data-desktop-menu-caret]');
            const hoverElement = button.querySelector('[data-menu-sub-menu]');
            if (svg.classList.contains('xLarge:rotate-180')) {
                svg.classList.remove('xLarge:rotate-180');
            }
            if (hoverElement && hoverElement.classList.contains('xLarge:opacity-100')) {
                console.log('remove xLarge:opacity-100');
                hoverElement.classList.remove('xLarge:opacity-100');
            }
        })
    }

    announcementBarCheck () {
        if (this.announcementBar) {
            // Adds additional padding to mobile sub menus
            document.querySelectorAll('div[data-sub-menu]').forEach(menu => {
                if (menu) {
                    menu.classList.add('xLargeMax:pt-9');
                }
            });
        }
    }
}

export default class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.getElementById('shopify-section-header');
        this.headerBounds = {};

        this.currentScrollTop = 0;
        this.preventReveal = false;

        this.predictiveSearch = this.querySelector('predictive-search');
        this.predictiveSearchModal = this.querySelector('modal-dialog[id=PredictiveSearch]');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        // Skip all sticky header logic if mobile menu is open
        const mobileMenu = document.querySelector('[data-mobile-menu]');
        if (mobileMenu && mobileMenu.classList.contains('xLargeMax:translate-x-0')) {
            return;
        }

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearchModal && this.predictiveSearchModal.classList.contains('is-active')) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            window.requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (!this.preventReveal) {
                window.requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                window.requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            window.requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.header.classList.add('-translate-y-full', 'overflow-hidden', 'sticky', 'top-0', 'z-20');
        this.closeMenuDisclosure();
    }

    reveal() {
        this.header.classList.add('header-is-sticky', 'sticky', 'top-0', 'z-20', 'transition-[transform_0.15s_ease-out]', 'bg-white');
        this.header.classList.remove('-translate-y-full', 'overflow-hidden');
    }

    reset() {
        this.header.classList.remove('header-is-sticky', '-translate-y-full', 'overflow-hidden', 'sticky', 'top-0', 'z-20', 'transition-[transform_0.15s_ease-out]');
    }

    closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
    }
}

export {
    Header,
    StickyHeader
}
